import type { User } from '@web/store/types/modules/user'

/**
 * True when the user has the «courses with selfie» segment.
 */
export function selectHasSelfieCourse (user: User | undefined | null): boolean {
  return !!user?.onboarding?.userCourseStreamWithSelfie
}
